<template>
  <el-dialog
    title="修改催收负责人"
    :visible.sync="dialogVisible"
    width="600px"
    @close="handleClose"
  >
    <el-form ref="form" :model="formData" label-width="120px">
      <el-form-item
        label="催收负责人"
        prop="dcUserId"
      >
        <SelectAdminUser v-model="formData.dcUserId" :job-code="AdminJobCode.A004" />
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit"> 提交 </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  updateDcUserAPI,
} from "../api/after-sales";
import SelectAdminUser from "@/views/components/select-admin-user.vue";
import { AdminJobCode } from "@/enum/dict/index.js";

export default {
  name: "DcUser",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    orderNo: {
      type: String,
      default: "",
    },
    dcUserId: {
      type: Number,
      default: undefined,
    }
  },
  components: {
    SelectAdminUser,
  },
  data() {
    return {
      dialogVisible: false,
      formData: {
        orderNo: "",
        dcUserId: undefined,
      },
      AdminJobCode,
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.resetForm();
      }
    },
    dialogVisible(val) {
      if (!val) {
        this.$emit("update:visible", false);
      }
    },
    orderNo(val) {
      if (this.dialogVisible) {
        this.formData.orderNo = val;
      }
    },
    dcUserId(val) {
      if (this.dialogVisible) {
        this.formData.dcUserId = val;
      }
    },
  },
  methods: {
    resetForm() {
      this.formData = {
        orderNo: this.orderNo || "",
        dcUserId: this.dcUserId || "",
      };
      if (this.$refs.form) {
        this.$refs.form.clearValidate();
      }
    },
    async handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          await updateDcUserAPI({
            orderNo: this.orderNo,
            dcUserId: this.formData.dcUserId || 0,
          });
          this.$message.success("操作成功");
          this.handleClose();
          this.$emit("success", {
            dcUserId: this.formData.dcUserId,
          });
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.resetForm();
    },
  },
};
</script>

<style lang="scss" scoped></style>
